import API from 'utils/API'

export const fetchMenu = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/menu${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteMenu = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/menu/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchMenuDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/menu/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createMenu = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/menu', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateMenu = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/menu/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchWebMenu = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/web/menu${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
